/* PageSection - uses .PageSection in tailwind.css (complex nested selectors, ::after) */
export const pageSectionClassName = 'PageSection';
